import ApiMethods from 'shared/api/api-methods';

import type { Tariffs } from '@/enteties/tariff/modal';
import { queryOptions } from '@tanstack/react-query';
import { tariffKeys } from '@/enteties/tariff/api/tariff.query-key';

export const allTariffs = {
  getTariffs: async function getTariffs(): Promise<Tariffs> {
    const data = await ApiMethods.get('/tariff?currency=RUB');
    if (!data.ok) throw Error(`${data.status}`);
    return data.json();
  },
  getAllTariffsQueryOptions: () =>
    queryOptions({
      queryKey: tariffKeys.tariffs,
      queryFn: () => allTariffs.getTariffs(),
      select: (data) => data.tariffs,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }),
};
